export default {
  Editing: {
    label: "Draft",
    color: "blue",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  },
  PendingApproval: {
    label: "Pending Approval",
    color: "yellow",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  },
  ChangesRequested: {
    label: "Changes Requested",
    color: "red",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  },
  Available: {
    label: "Live",
    color: "green",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  },
  Closed: {
    label: "Closed",
    color: "gray",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  },
  HoldingUnproven: {
    label: "Paused",
    color: "gray",
    hasStatus: false,
    canBeAssigned: false,
    requiresApprovalToChange: false
  }
};
